var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 12.4173H15.0416V14.8965L16.71 15.8823L16.2725 16.594L14.1666 15.334V12.4173ZM18.8333 14.7507C18.8333 15.8336 18.4031 16.8722 17.6373 17.638C16.8716 18.4038 15.8329 18.834 14.75 18.834C13 18.834 11.4833 17.714 10.9116 16.1507L10.0833 15.859L6.96831 17.0665L6.87498 17.084C6.79762 17.084 6.72344 17.0533 6.66874 16.9986C6.61404 16.9439 6.58331 16.8697 6.58331 16.7923V7.97232C6.58331 7.83815 6.67081 7.73315 6.79331 7.69232L10.0833 6.58398L13.5833 7.80898L16.6983 6.58398H16.7916C16.869 6.58398 16.9432 6.61471 16.9979 6.66941C17.0526 6.72411 17.0833 6.7983 17.0833 6.87565V11.3965C18.1391 12.1257 18.8333 13.3623 18.8333 14.7507ZM10.6666 14.7507C10.6666 12.9015 11.8975 11.3382 13.5833 10.8365V8.98148L10.0833 7.75065V14.6865L10.6666 14.8907V14.7507ZM14.75 11.834C13.9764 11.834 13.2346 12.1413 12.6876 12.6883C12.1406 13.2352 11.8333 13.9771 11.8333 14.7507C11.8333 15.5242 12.1406 16.2661 12.6876 16.813C13.2346 17.36 13.9764 17.6673 14.75 17.6673C15.5235 17.6673 16.2654 17.36 16.8124 16.813C17.3594 16.2661 17.6666 15.5242 17.6666 14.7507C17.6666 13.9771 17.3594 13.2352 16.8124 12.6883C16.2654 12.1413 15.5235 11.834 14.75 11.834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneFilledIcon);
export default __webpack_public_path__ + "static/media/zone-filled-icon.3f13dcdcb2510db5b8fa19bdfa0040e9.svg";
export { ForwardRef as ReactComponent };